import { render } from "./MijnOverzichtView.vue?vue&type=template&id=37806051"
import script from "./MijnOverzichtView.vue?vue&type=script&lang=js"
export * from "./MijnOverzichtView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__